import { render } from "./HeroiconsSolidBriefcase.vue?vue&type=template&id=a07d9244"
const script = {}

import exportComponent from "/var/www/doughcoteam.co.uk/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidBriefcase.vue"]])

export default __exports__